import { render, staticRenderFns } from "./CollectiveActions.vue?vue&type=template&id=6c79a100&scoped=true"
import script from "./CollectiveActions.vue?vue&type=script&lang=js"
export * from "./CollectiveActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c79a100",
  null
  
)

export default component.exports